import React, { useState, useEffect } from 'react';
import {
  Row, Col, Typography, Form, Select,
  Input, DatePicker,
} from 'antd';
import CurrencyInput from 'react-currency-input';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import { getUserType } from '../../../../../utils/users';
import './DetailsFields.scss';

const Details = (props) => {
  const {
    formInstance, initialValuesObject, mode, edit, listPeriods, detail,
  } = props;

  const [optionPeriod, setOptionPeriod] = useState(false);
  const listOrderType = [
    'Interna',
    'Externa',
  ];

  const handleChangePeriod = (value) => {
    (
      value === 'Diária'
        ? setOptionPeriod(true)
        : setOptionPeriod(false)
    );
  };

  useEffect(() => {
    (
      initialValuesObject?.['intervalPeriod']
        ? setOptionPeriod(true)
        : setOptionPeriod(false)
    );
  }, []);

  return (
    <>
      <Row
        gutter={[24, 24]}
        className="LocacaoPilotoDetails__GridSizeRow"
      >
        <Col
          xs={{ span: 24 }}
          className="LocacaoPilotoDetails__GridSizeColumn"
        >
          <Form.Item
            label={(
              <Typography.Title
                level={5}
                className="LocacaoPilotoDetails__GridSizeTitle LocacaoPilotoDetails__AllFormLabels"
              >
                Qual o município em que se encontra o equipamento?
              </Typography.Title>
            )}
            name="POS_VENDA_LOCACAO_DE_PILOTO_MUNICIPIO"
            className="LocacaoPilotoDetails__GridSizeFormItem"
            rules={[]}
            initialValue={initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO_MUNICIPIO']}
          >
            <Input
              style={{ width: '100%' }}
              maxLength={50}
              disabled={edit}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="LocacaoPilotoDetails__GridSizeRow"
      >
        <Col
          xs={{ span: 24 }}
          className="LocacaoPilotoDetails__GridSizeColumn"
        >
          <Form.Item
            label={(
              <Typography.Title
                level={5}
                className="LocacaoPilotoDetails__GridSizeTitle LocacaoPilotoDetails__AllFormLabels"
              >
                Modelo
              </Typography.Title>
            )}
            name="POS_VENDA_LOCACAO_DE_PILOTO_MODELO"
            className="LocacaoPilotoDetails__GridSizeFormItem"
            rules={[]}
            initialValue={initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO_MODELO']}
          >
            <Input
              style={{ width: '100%' }}
              maxLength={100}
              disabled={edit}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={24}
        className="inline-field"
      >
        <Col span={24}>
          <Form.Item
            name={'POS_VENDA_LOCACAO_DE_PILOTO_PERIODO_DESEJADO'}
            rules={[]}
            label={(
              <span
                className="LocacaoPilotoDetails__PRNTCalcarioTitle LocacaoPilotoDetails__AllFormLabels"
              >
                Período desejado
              </span>
            )}
            initialValue={initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO_PERIODO_DESEJADO'] || undefined}
          >
            <Select disabled={edit} className="LocacaoPilotoDetails__GridSizeSelect" onChange={handleChangePeriod}>
              {
                listPeriods && listPeriods.map((_item) => (
                  <Select.Option key={_item} value={_item}>
                    {_item}
                  </Select.Option>
                ))
              }
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {
        optionPeriod === true
          ? (
            <Row
              gutter={24}
              className="inline-field"
            >
              <Col span={24}>
                <Form.Item
                  name={'intervalPeriod'}
                  rules={[]}
                  label={(
                    <span
                      className="LocacaoPilotoDetails__PRNTCalcarioTitle LocacaoPilotoDetails__AllFormLabels"
                    >
                      Período
                    </span>
                  )}
                  initialValue={initialValuesObject?.['intervalPeriod'] || [moment().subtract(30, 'day'), moment()]}
                >
                  <DatePicker.RangePicker
                    className="ListServiceEstimates__IntervalFilterDatePicker"
                    style={{ width: '100%' }}
                    placeholder="Intervalo de tempo"
                    format="DD/MM/YYYY"
                  />
                </Form.Item>
              </Col>
            </Row>
          )
          : null
      }

      {
        edit === true
          && initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_INICIO']
          && initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_FIM']
          ? (
            <Row
              gutter={[24, 24]}
              className="LocacaoPilotoDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 12 }}
                className="LocacaoPilotoDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="LocacaoPilotoDetails__GridSizeTitle LocacaoPilotoDetails__AllFormLabels"
                    >
                      Início
                    </Typography.Title>
                  )}
                  name="POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_INICIO"
                  className="LocacaoPilotoDetails__GridSizeFormItem"
                  rules={[]}
                  initialValue={initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_INICIO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    maxLength={100}
                    disabled={edit}
                  />
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 12 }}
                className="LocacaoPilotoDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="LocacaoPilotoDetails__GridSizeTitle LocacaoPilotoDetails__AllFormLabels"
                    >
                      Fim
                    </Typography.Title>
                  )}
                  name="POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_FIM"
                  className="LocacaoPilotoDetails__GridSizeFormItem"
                  rules={[]}
                  initialValue={initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_FIM']}
                >
                  <Input
                    style={{ width: '100%' }}
                    maxLength={100}
                    disabled={edit}
                  />
                </Form.Item>
              </Col>
            </Row>
          )
          : null
      }

      {
        edit === true && initialValuesObject?.[`POS_VENDA_LOCACAO_DE_PILOTO_TIPO_ORDEM`] && getUserType() === 'COOPERCITRUS'
          ? (
            <Row
              gutter={24}
              className="inline-field"
            >
              <Col span={24}>
                <Form.Item
                  name={`POS_VENDA_LOCACAO_DE_PILOTO_TIPO_ORDEM`}
                  rules={[
                    {
                      required: true,
                      message: 'O campo é obrigatório',
                    },
                  ]}
                  label={(
                    <span
                      className="LocacaoPilotoDetails__PRNTCalcarioTitle LocacaoPilotoDetails__AllFormLabels"
                    >
                      Tipo de ordem
                    </span>
                  )}
                  initialValue={initialValuesObject?.[`POS_VENDA_LOCACAO_DE_PILOTO_TIPO_ORDEM`] || undefined}
                >
                  <Select disabled={edit} className="LocacaoPilotoDetails__GridSizeSelect">
                    {
                      listOrderType.map((_item) => (
                        <Select.Option key={_item} value={_item}>
                          {_item}
                        </Select.Option>
                      ))
                    }
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )
          : edit === undefined && getUserType() === 'COOPERCITRUS'
            ? (
              <Row
                gutter={24}
                className="inline-field"
              >
                <Col span={24}>
                  <Form.Item
                    name={`POS_VENDA_LOCACAO_DE_PILOTO_TIPO_ORDEM`}
                    rules={[
                      {
                        required: true,
                        message: 'O campo é obrigatório',
                      },
                    ]}
                    label={(
                      <span
                        className="LocacaoPilotoDetails__PRNTCalcarioTitle LocacaoPilotoDetails__AllFormLabels"
                      >
                        Tipo de ordem
                      </span>
                    )}
                    initialValue={initialValuesObject?.[`POS_VENDA_LOCACAO_DE_PILOTO_TIPO_ORDEM`] || undefined}
                  >
                    <Select disabled={edit} className="LocacaoPilotoDetails__GridSizeSelect">
                      {
                        listOrderType.map((_item) => (
                          <Select.Option key={_item} value={_item}>
                            {_item}
                          </Select.Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )
            : null
      }

      {
        getUserType() === 'COOPERCITRUS' && !detail
        && (
          <>
            <Row gutter={[24, 24]}>
              <Col xs={{ span: 24 }}>
                <hr />
                <p className="LocacaoPilotoDetails__SessionTitle">Orçamento</p>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="LocacaoPilotoDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="LocacaoPilotoDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="LocacaoPilotoDetails__GridSizeTitle LocacaoPilotoDetails__AllFormLabels"
                    >
                      Valor unitário
                    </Typography.Title>
                  )}
                  name="POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO"
                  className="LocacaoPilotoDetails__GridSizeFormItem"
                  rules={[
                    {
                      validator: (rule, value) => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO']
                        ? initialValuesObject['POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="LocacaoPilotoDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="LocacaoPilotoDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="LocacaoPilotoDetails__GridSizeTitle LocacaoPilotoDetails__AllFormLabels"
                    >
                      Valor total
                    </Typography.Title>
                  )}
                  name="POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL"
                  className="LocacaoPilotoDetails__GridSizeFormItem"
                  rules={[
                    {
                      validator: (rule, value) => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL']
                        ? initialValuesObject['POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="LocacaoPilotoDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="LocacaoPilotoDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="LocacaoPilotoDetails__GridSizeTitle LocacaoPilotoDetails__AllFormLabels"
                    >
                      Condição de pagamento
                    </Typography.Title>
                  )}
                  name="POS_VENDA_LOCACAO_DE_PILOTO-CONDICAO_PAGAMENTO"
                  className="LocacaoPilotoDetails__GridSizeFormItem"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO-CONDICAO_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="LocacaoPilotoDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="LocacaoPilotoDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="LocacaoPilotoDetails__GridSizeTitle LocacaoPilotoDetails__AllFormLabels"
                    >
                      Forma de pagamento
                    </Typography.Title>
                  )}
                  name="POS_VENDA_LOCACAO_DE_PILOTO-FORMA_PAGAMENTO"
                  className="LocacaoPilotoDetails__GridSizeFormItem"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO-FORMA_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="LocacaoPilotoDetails__GridSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="LocacaoPilotoDetails__GridSizeColumn"
              >
                <Form.Item
                  label={(
                    <Typography.Title
                      level={5}
                      className="LocacaoPilotoDetails__GridSizeTitle LocacaoPilotoDetails__AllFormLabels"
                    >
                      Observações do orçamento
                    </Typography.Title>
                  )}
                  name="POS_VENDA_LOCACAO_DE_PILOTO-OBSERVACOES"
                  className="LocacaoPilotoDetails__GridSizeFormItem"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['POS_VENDA_LOCACAO_DE_PILOTO-OBSERVACOES']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )
      }

    </>
  );
};

Details.propTypes = {
  formInstance: PropTypes.shape({
    getFieldValue: PropTypes.func.isRequired,
    validateFields: PropTypes.func.isRequired,
  }).isRequired,

  mode: PropTypes.oneOf(['CREATE', 'EDIT']).isRequired,
  listPeriods: PropTypes.objectOf(PropTypes.any).isRequired,

  initialValuesObject: PropTypes.shape({
    POS_VENDA_LOCACAO_DE_PILOTO_MUNICIPIO: PropTypes.string,
    POS_VENDA_LOCACAO_DE_PILOTO_MODELO: PropTypes.string,
    POS_VENDA_LOCACAO_DE_PILOTO_PERIODO_DESEJADO: PropTypes.oneOfType([
      PropTypes.string, PropTypes.number]),
    POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_INICIO: PropTypes.string,
    POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_FIM: PropTypes.string,
    POS_VENDA_LOCACAO_DE_PILOTO_TIPO_ORDEM: PropTypes.string,
    'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_LOCACAO_DE_PILOTO-CONDICAO_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_LOCACAO_DE_PILOTO-FORMA_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_LOCACAO_DE_PILOTO-OBSERVACOES': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  edit: PropTypes.bool,
  detail: PropTypes.bool,
};
Details.defaultProps = {
  detail: false,
};

export default Details;
